import { render, staticRenderFns } from "./ModalGerarQuitacaoDQ.vue?vue&type=template&id=2d0243b8"
import script from "./ModalGerarQuitacaoDQ.vue?vue&type=script&lang=js"
export * from "./ModalGerarQuitacaoDQ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports